import { MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Card: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  min-height: 80px;
  cursor: pointer;
  font-size: 12px;
  border-bottom: 1px solid ${ColorPalette.HEX.LightGray2};
`;

Card.Name = styled.span`
  line-height: 1.5;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.group.subTitle};
`;

Card.Address = styled.span`
  line-height: 1.5;
  font-size: 12px;
  font-weight: normal;
  color: ${({ theme }) => theme.group.subTitle};
`;

Card.Icon = styled.img`
  height: 24px;
  width: 24px;
  margin: 0 24px 0 16px;
  object-fit: contain;
`;

Card.ArrowIcon = styled(MdKeyboardArrowRight).attrs<any>((): any => ({}))`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty} !important;
  margin-left: auto;
`;

Card.Detail = styled.div`
  display: flex;
  width: 100%;
  flex: 2;
  flex-direction: column;
`;
